export default __webpack_public_path__ + "static/media/14.8c723a93.jpg";